import {
  addUploadBreadcrumb,
  captureImageUploadError,
  extractAxiosErrorInfo,
  newCorrelationId,
  reportEvent,
} from "../../service/monitoring";
import {
  Box,
  Grid,
  TextField,
  Typography,
  Autocomplete,
  Button,
  IconButton,
} from "@mui/material";
import axios from "axios";
import { useEffect, useRef, useState } from "react";
import { api_base } from "../../env";
import { useNavigate, useParams } from "react-router";
import BackLoading from "../../composant/loading/backLoading";
import { useDispatch, useSelector } from "react-redux";
import { VidePanier } from "../../store/slice/gestionImageSlice";
import { ImportButton } from "../../composant/UploadFiles";
import { StorageDataClient } from "../../store/slice/InfoClientSlice";
import SuccessWithRouletteDialog from "../../composant/Popup/PopupRoulleteSucces";
import { GetDataRoulleteByMagasin } from "../../store/slice/DataApp";
import Cookies from "js-cookie";
import BarUploadProduct from "../../composant/bar/BarUploadProduct";
import SousTitreTypography from "../../composant/Typography/SousTitreTypography";
import AddIcon from "@mui/icons-material/Add";
import BottomBar from "../../composant/navbar/ButtomBar";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
export default function InfoClient() {
  const formRef = useRef();
  const submitting = useRef(false);
  const Navigate = useNavigate();
  const [magasinid, setMagasinid] = useState("");
  const [Loading, setLoading] = useState(false);
  const [Progress, setProgress] = useState(0);
  const [codeCommand, setCodeCommand] = useState();
  const magasin = useSelector((state) => state.dataApp.Magasins);
  const clientInfo = useSelector((state) => state.InfoCommand.clientCommand);
  const allImages = useSelector((state) => state.gestionImage.allImages);
  const photos = useSelector((state) => state.gestionImage.allImages);
  const { type } = useParams();
  const { Produits } = useSelector((state) => state.dataApp);
  const photoTypes = Object.keys(photos).filter(
    (key) => photos[key].length > 0
  );
  const [Roullete, setRoullete] = useState(false);
  const [open, setOpen] = useState(true);
  const [idCommand, setIdCommand] = useState();
  const [clientType, setClientType] = useState();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [errors, setErrors] = useState({});
  useEffect(() => {
    setMagasinid(clientInfo.magasin);
  }, [clientInfo]);
  function sanitizeFileName(name) {
    return name.replace(/[^a-zA-Z0-9-_]/g, "_");
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = new FormData(formRef.current);
    const telephone = form.get("telephone")?.trim();
    const nom = form.get("nom")?.trim();
    const adresse = form.get("adresse")?.trim();
    const magasinValue = magasin.find((m) => m.id === magasinid);

    const newErrors = {};

    // Validate phone number (simple regex Maroc 9 digits)
    if (!telephone || !/^\d{9,15}$/.test(telephone)) {
      newErrors.telephone = "Numéro de téléphone invalide (9-15 chiffres)";
    }

    if (!nom) {
      newErrors.nom = "Le nom est obligatoire";
    }

    if (type === "inStore") {
      if (!magasinValue) {
        newErrors.magasin = "Veuillez sélectionner un magasin";
      }
    } else {
      if (!adresse) {
        newErrors.adresse = "L'adresse est obligatoire";
      }
    }

    setErrors(newErrors);

    // If no errors, proceed
    if (Object.keys(newErrors).length === 0) {
      NewCommand(e);
    }
  };
  async function NewCommand(e) {
    e.preventDefault();
    if (submitting.current) return;
    submitting.current = true;
    setLoading(true);
    setProgress(0);
    const startedAt = Date.now();
    let stage = "order_prepare";
    const uploadData = { delivery_type: type, file_count: 0, total_bytes: 0 };
    const correlationId = newCorrelationId();
    const endpoint = `${api_base}command/Add`;
    try {
      const { nom, telephone, adresse, code } = e.target;
      const formData = new FormData();
      formData.append("nom", nom.value);
      formData.append("telephone", telephone.value);
      formData.append("adresse", adresse?.value || null);
      formData.append("magasin", magasinid);
      formData.append("code", code?.value || null);
      var dataFiles = [];
      Object.keys(allImages).forEach((key, i) => {
        allImages[key].forEach((item, j) => {
          uploadData.file_count += 1;
          uploadData.total_bytes += item.file?.size || 0;
          const safeName = sanitizeFileName(`${item.name}${i}${j}`);
          formData.append(safeName, item.file);
          const dataFile = {
            nomFile: safeName,
            idproduit: item.idProduit,
            text: item.text ? item.text : null,
            count: item.count ? item.count : 1,
            color: item.color ? item.color : null,
            srcRm: item.srcRm || null,
            bg: item.Bg ? item.Bg.Url : null,
            documentType: item.documentType ? item.documentType : null,
          };
          dataFiles.push(dataFile);
        });
      });
      formData.append("dataFiles", JSON.stringify(dataFiles));
      stage = "order_upload";
      reportEvent("order_upload.started", { ...uploadData, correlationId });
      addUploadBreadcrumb("upload_started", { ...uploadData, correlationId, endpoint });
      await axios
        .post(endpoint, formData, {
          onUploadProgress: (progressEvent) => {
            let percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            if (Number.isFinite(percentCompleted)) setProgress(percentCompleted);
          },
        })
        .then((response) => {
          addUploadBreadcrumb("upload_response_received", { status: response.status });
          reportEvent("order_upload.completed", { ...uploadData, status: response.status, duration_ms: Date.now() - startedAt, correlationId });
          addUploadBreadcrumb("upload_success", { correlationId });
          stage = "order_finalize";
          dispatch(GetDataRoulleteByMagasin(magasinid));
          setCodeCommand(response.data.code);

          setIdCommand(response.data.idCommand);
          setClientType(response.data.typeClient);

          setRoullete(true);
          dispatch(VidePanier());
          const expirationDate = new Date();
          expirationDate.setDate(expirationDate.getDate() + 2);
          Cookies.set("codeCommand", response.data.code, {
            expires: expirationDate,
          });
        });
      const data = {
        nom: nom.value,
        telephone: telephone.value,
        adresse: adresse?.value || null,
        magasin: magasinid,
      };
      dispatch(StorageDataClient(data));
    } catch (error) {
      addUploadBreadcrumb("upload_failed", { correlationId, stage });
      await captureImageUploadError({
        error,
        stage,
        product: { type },
        correlationId,
        requestInfo: extractAxiosErrorInfo(error, { method: "POST", url: endpoint }),
        extra: { ...uploadData, duration_ms: Date.now() - startedAt },
      });
      alert(error.message || "Unknown error");
    } finally {
      submitting.current = false;
      setLoading(false);
    }
  }

  const totalPrice = photoTypes.reduce((total, photoType) => {
    const produit = Produits.find((p) => p.NomProduit === photoType);
    if (produit) {
      const totalCount = (photos[photoType] || []).reduce(
        (sum, p) => sum + (p.count || 0),
        0
      );

      const prixUnitaire = produit?.promoCount
        ? PriceProductByCounter(produit.prix, photoType)
        : produit.prix;

      return total + prixUnitaire * totalCount;
    }
    return total;
  }, 0);

  function PriceProductByCounter(prix, photoType) {
    let prixFinal = 0;
    const count = photos[photoType].reduce(
      (total, p) => total + (p.count || 0),
      0
    );
    if (count >= 30) {
      prixFinal = prix * 0.6;
    } else if (count >= 10) {
      prixFinal = prix * 0.8;
    } else {
      prixFinal = prix;
    }
    return prixFinal;
  }

  return (
    <>
      <div style={{ background: "#f7f7f7", minHeight: "100vh" }}>
        <BarUploadProduct
          titre="Ma Commande"
          sousTitre="Panier"
          beforeOnClik={() => {
            navigate(-1);
          }}
        />
        <Grid
          container
          sx={{ marginTop: "20px", marginBottom: "60px" }}
          spacing={2}
        >
          <Grid item xs={12}>
            <Box
              sx={{
                background: "white",
                width: "90%",
                marginLeft: "5%",
                borderRadius: "10px",
                padding: "20px",
              }}
            >
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                    }}
                  >
                    <SousTitreTypography>
                      Liste et Prix de votre commande
                    </SousTitreTypography>
                    <Box>
                      {open ? (
                        <IconButton
                          onClick={() => {
                            setOpen(!open);
                          }}
                        >
                          <KeyboardArrowUpIcon sx={{ color: "#E63D57" }} />
                        </IconButton>
                      ) : (
                        <IconButton
                          onClick={() => {
                            setOpen(!open);
                          }}
                        >
                          <KeyboardArrowDownIcon sx={{ color: "#E63D57" }} />
                        </IconButton>
                      )}
                    </Box>
                  </Box>
                </Grid>
                {open && (
                  <>
                    {photoTypes.map((photoType, index) => {
                      const produit = Produits.find(
                        (p) => p.NomProduit === photoType
                      );

                      return (
                        <Grid item xs={12}>
                          <Box
                            sx={{
                              background: "white",
                              borderRadius: "20px",
                              width: "100%",
                            }}
                          >
                            <Grid container spacing={2}>
                              <Grid item xs={4}>
                                {" "}
                                <img
                                  src={produit?.PanierImage}
                                  style={{
                                    maxHeight: "60px",
                                    maxWidth: "60px",
                                    height: "auto",
                                    width: "auto",
                                    borderRadius: "12px",
                                  }}
                                  alt={photoType}
                                />
                              </Grid>
                              <Grid item xs={4}>
                                <Box
                                  sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",

                                    height: "100%",
                                    width: "100%",
                                  }}
                                >
                                  <Typography
                                    sx={{
                                      fontFamily: "F37 Ginger",
                                      fontWeight: 400,
                                      fontStyle: "normal", // Regular تعني normal في CSS
                                      fontSize: "14px",
                                      lineHeight: "100%",
                                      letterSpacing: "0%",
                                      verticalAlign: "middle",
                                      color: "#32324D",
                                      textAlign: "left",
                                    }}
                                  >
                                    Tirage {photoType}
                                  </Typography>
                                </Box>
                              </Grid>
                              <Grid item xs={4}>
                                <Box
                                  sx={{
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    gap: "4px",
                                    height: "100%",
                                    width: "100%",
                                  }}
                                >
                                  <Typography
                                    component="span"
                                    sx={{
                                      fontFamily: "Montserrat, sans-serif",
                                      fontWeight: 700,
                                      fontSize: "14px",
                                      lineHeight: "100%",
                                      color: "#4A4A6A",
                                    }}
                                  >
                                    {produit?.promoCount
                                      ? PriceProductByCounter(
                                          produit?.prix,
                                          photoType
                                        )
                                      : produit?.prix}
                                  </Typography>

                                  <Typography
                                    component="span"
                                    sx={{
                                      fontFamily: "Montserrat, sans-serif",
                                      fontWeight: 700,
                                      fontSize: "8px",
                                      lineHeight: "15px",
                                      color: "#8E8EA9",
                                    }}
                                  >
                                    Dhs
                                  </Typography>

                                  <Typography
                                    component="span"
                                    sx={{
                                      fontFamily: "Montserrat",
                                      fontWeight: 700,
                                      fontSize: "8px",
                                      lineHeight: "20px",
                                      color: "#C0C0CF",
                                    }}
                                  >
                                    X
                                  </Typography>

                                  <Typography
                                    component="span"
                                    sx={{
                                      fontFamily: "Montserrat, sans-serif",
                                      fontWeight: 700,
                                      fontSize: "14px",
                                      lineHeight: "20px",
                                      color: "#A5A5BA",
                                    }}
                                  >
                                    {photos[photoType]
                                      ? photos[photoType].reduce(
                                          (total, p) => total + (p.count || 0),
                                          0
                                        )
                                      : 0}
                                  </Typography>
                                </Box>
                              </Grid>
                            </Grid>
                          </Box>
                        </Grid>
                      );
                    })}
                    <Grid item xs={12}>
                      <Typography
                        sx={{
                          fontFamily: "Montserrat, sans-serif",
                          fontWeight: 700,
                          fontSize: "16px",
                          textAlign: "right",
                          marginTop: "16px",
                          color: "#32324D",
                        }}
                      >
                        Total : {totalPrice} Dhs
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Button
                        onClick={() => navigate("/")}
                        sx={{
                          borderRadius: "16px",
                          height: "50px",
                          zIndex: 10,
                          padding: "2%",
                          fontFamily: "Mulish, sans-serif",
                          textTransform: "none",
                          borderColor: "#E9535D",
                          color: "#E9535D",
                          backgroundColor: "white",
                          "&:hover": {
                            backgroundColor: "#E9535D",
                            color: "white",
                            borderColor: "#E9535D",
                          },
                          marginBottom: "2%",
                        }}
                        variant="outlined"
                        fullWidth
                        startIcon={<AddIcon />}
                      >
                        Ajouter des Produits
                      </Button>
                    </Grid>
                  </>
                )}
              </Grid>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Box component="form" onSubmit={handleSubmit} ref={formRef}>
              <Grid
                container
                rowSpacing={4}
                marginTop="4%"
                width="40%"
                marginLeft="30%"
                sx={{
                  marginTop: "4%",
                  width: "40%",
                  marginLeft: "30%",
                  "@media (max-width: 700px)": {
                    width: "100%",
                    marginLeft: "0%",
                    padding: "3%",
                  },
                }}
              >
                <Grid item xs={12}>
                  <Typography variant="h3" fontSize={20} textAlign="center">
                    Je m'inscris et je confirme ma commande
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    placeholder="telephone"
                    name="telephone"
                    label="telephone"
                    fullWidth
                    required
                    defaultValue={clientInfo?.telephone}
                    error={!!errors.telephone}
                    helperText={errors.telephone}
                  />
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    placeholder="Nom"
                    label="Nom"
                    name="nom"
                    fullWidth
                    required
                    defaultValue={clientInfo?.nom}
                    error={!!errors.nom}
                    helperText={errors.nom}
                  />
                </Grid>

                {type === "inStore" ? (
                  <Grid item xs={12}>
                    <Autocomplete
                      disablePortal
                      id="magasin"
                      options={magasin}
                      getOptionLabel={(option) => option.Nom || ""}
                      value={
                        magasin.find((option) => option.id === magasinid) ||
                        null
                      }
                      onChange={(e, newValue) => {
                        if (newValue) {
                          setMagasinid(newValue.id);
                        } else {
                          setMagasinid(null);
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Magasin"
                          required
                          name="magasin"
                          error={!!errors.magasin}
                          helperText={errors.magasin}
                        />
                      )}
                    />
                  </Grid>
                ) : (
                  <Grid item xs={12}>
                    <TextField
                      placeholder="Adresse"
                      label="Adresse"
                      name="adresse"
                      defaultValue={clientInfo?.adresse}
                      fullWidth
                      required
                      error={!!errors.adresse}
                      helperText={errors.adresse}
                    />
                  </Grid>
                )}

                <Grid item xs={12}>
                  <ImportButton
                    disabled={Loading || Object.values(allImages).every(
                      (arr) => !arr || arr.length === 0
                    )}
                    variant="contained"
                    type="submit"
                    fullWidth
                  >
                    commande
                  </ImportButton>
                </Grid>
              </Grid>
              <BottomBar />
            </Box>

            <SuccessWithRouletteDialog
              open={Roullete}
              code={codeCommand}
              clientType={clientType}
              idCommande={idCommand}
              onClose={() => {
                setRoullete(false);
                Navigate("/");
              }}
            />
          </Grid>
        </Grid>
        {/** <Box>
          <Box component="form" onSubmit={NewCommand} ref={formRef}>
            <Typography variant="h3" fontSize={40} textAlign="center">
              info client
            </Typography>
            <Grid
              container
              rowSpacing={4}
              marginTop="4%"
              width="40%"
              marginLeft="30%"
              sx={{
                marginTop: "4%",
                width: "40%",
                marginLeft: "30%",
                "@media (max-width: 700px)": {
                  width: "100%",
                  marginLeft: "0%",
                  padding: "3%",
                },
              }}
            >
              <Grid item xs={12}>
                <Typography variant="h3" fontSize={20} textAlign="center">
                  Je m'inscris et je confirme ma commande
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  placeholder="telephone"
                  name="telephone"
                  label="telephone"
                  fullWidth
                  required
                  defaultValue={clientInfo?.telephone}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  placeholder="Nom"
                  label="Nom"
                  name="nom"
                  fullWidth
                  required
                  defaultValue={clientInfo?.nom}
                />
              </Grid>

              {type === "inStore" ? (
                <Grid item xs={12}>
                  <Autocomplete
                    disablePortal
                    id="magasin"
                    options={magasin}
                    getOptionLabel={(option) => option.Nom || ""}
                    value={
                      magasin.find((option) => option.id === magasinid) || null
                    }
                    onChange={(e, newValue) => {
                      if (newValue) {
                        setMagasinid(newValue.id);
                      } else {
                        setMagasinid(null); // Handle the case where the value is cleared
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Magasin"
                        required
                        name="magasin"
                      />
                    )}
                  />
                </Grid>
              ) : (
                <Grid item xs={12}>
                  <TextField
                    placeholder="Adresse"
                    label="Adresse"
                    name="adresse"
                    defaultValue={clientInfo?.adresse}
                    fullWidth
                    required
                  />
                </Grid>
              )}

              <Grid item xs={12}>
                <ImportButton
                  disabled={Loading || Object.values(allImages).every(
                    (arr) => !arr || arr.length === 0
                  )}
                  variant="contained"
                  type="submit"
                  fullWidth
                >
                  commande
                </ImportButton>
              </Grid>
            </Grid>
          </Box>

          <SuccessWithRouletteDialog
            open={Roullete}
            code={codeCommand}
            clientType={clientType}
            idCommande={idCommand}
            onClose={() => {
              setRoullete(false);
              Navigate("/");
            }}
          />
          <BackLoading open={Loading} Progress={Progress} />
        </Box> */}
        <BackLoading open={Loading} Progress={Progress} />
      </div>
    </>
  );
}
